import {
  MESSAGE_SENDER,
  MESSAGE_TYPES,
  // BUTTON_SUB_TYPES,
  BUTTON_TYPES,
} from "./constants"

export const getDefaultMessagesByKey = (key = "web") => {
  const defaultMessgaes = {
    web: [
      {
        cmid: "msg2",
        sender: MESSAGE_SENDER.CHATBOT,
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        inputLock: false,
        inputLockMessage: '',
        quickReplies: ["Recharge", "Network", "Bill Payment", "SIM Services", "Prepaid", "Postpaid", "Join Vi Family", "हिंदी भाषा में दिखाएं"],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',

        delay: 0,
        payload: {
          title: "",
          subtitle: "What would you like to explore today like to explore today like to explore today?",
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              variant: "card",
              text: "Recharge",
              subtitle: "Plan From rs19",
              url: "",
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#ea3a52" stroke-width="2"><path d="M13 2 3 14h7l-1 8 11-14h-7l1-6z"/></svg>',
              card: {
                style: {
                  background: "	linear-gradient(135deg,#FCE3E7 0%,#FDF5F1 100%)",
                  height:"120px"
                },
              }
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              variant: "card",
              text: "Network",
              subtitle: "Check 5G in your area",
              url: "",
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#ea3a52" stroke-width="2"><path d="M13 2 3 14h7l-1 8 11-14h-7l1-6z"/></svg>',
              card: {
                style: {
                  background: "linear-gradient(135deg,#FDF2D9 0%,#FEFBF1 100%)",
                   height:"120px"
                },
              }
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              variant: "card",
              text: "Bill Payment",
              subtitle: "Pay & download bill",
              url: "",
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#ea3a52" stroke-width="2"><path d="M13 2 3 14h7l-1 8 11-14h-7l1-6z"/></svg>',
              card: {
                style: {
                  background: "linear-gradient(135deg,#E5EFFB 0%,#F4EFFA 100%)",
                   height:"120px"
                },
              }
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              variant: "card",
              text: "SIM Services",
              subtitle: "Port, upgrade & more",
              url: "",
              icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#ea3a52" stroke-width="2"><path d="M13 2 3 14h7l-1 8 11-14h-7l1-6z"/></svg>',
              card: {
                style: {
                  background: "linear-gradient(135deg, #d9e8ff 0%, #f0f6ff 100%)",
                   height:"120px"
                },
              }
            },
          ]
        },
        timestamp: new Date(),
      },
       {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
         quickReplies: ["Recharge", "Network", "Bill Payment", "SIM Services", "Prepaid", "Postpaid", "Join Vi Family", "हिंदी भाषा में दिखाएं"],
        skipLS: false,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: '',
        delay: 0,
        payload: {
          containsHtmlTitle: true,
          cardStyle: {
            background: "linear-gradient(140deg,#D02D22 0%,#AE1E17 100%)",
          },
          title:"<div style=\"max-width:380px;margin:auto;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,Arial,Helvetica,sans-serif;border-radius:22px;padding:18px;background:linear-gradient(140deg,#D02D22 0%,#AE1E17 100%);\"><div style=\"overflow:hidden;margin-bottom:8px;\"><span style=\"float:right;display:inline-block;padding:6px 11px;border-radius:999px;background:#F3D63C;color:#2B2100;font-size:10px;font-weight:700;letter-spacing:.5px;line-height:1;\">PENDING PAYMENT</span><span style=\"display:inline-block;font-size:11px;font-weight:600;letter-spacing:1.8px;color:rgba(255,255,255,.9);line-height:22px;\">AMOUNT DUE</span></div><div style=\"font-size:32px;font-weight:700;color:#fff;line-height:1.1;letter-spacing:-.5px;\">&#8377;2,383.74</div><div style=\"font-size:13px;color:rgba(255,255,255,.85);margin-top:5px;\">Due on 07 May 2026</div><div style=\"margin-top:16px;padding:12px 14px;border-radius:12px;background:rgba(255,255,255,.13);font-size:13px;color:#fff;line-height:1.4;\"><svg width=\"15\" height=\"15\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"vertical-align:-2px;margin-right:8px;\"><rect x=\"3\" y=\"5\" width=\"18\" height=\"16\" rx=\"2.5\"/><path d=\"M8 3v4\"/><path d=\"M16 3v4\"/><path d=\"M3 10h18\"/></svg>Avoid late fee by paying before the due date.</div></div>",
          // title: "<div style=\"box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,Arial,Helvetica,sans-serif;padding:13px;\"><div style=\"overflow:hidden;margin-bottom:10px;\"><span style=\"float:right;display:inline-block;padding:7px 13px;border-radius:999px;background:#F3D63C;color:#2B2100;font-size:12px;font-weight:700;letter-spacing:.5px;line-height:1;\">PENDING PAYMENT</span><span style=\"display:inline-block;font-size:13px;font-weight:600;letter-spacing:2px;color:rgba(255,255,255,.9);line-height:26px;\">AMOUNT DUE</span></div><div style=\"font-size:38px;font-weight:700;color:#fff;line-height:1.1;letter-spacing:-.5px;\">&#8377;2,383.74</div><div style=\"font-size:16px;color:rgba(255,255,255,.85);margin-top:6px;\">Due on 07 May 2026</div><div style=\"margin-top:18px;padding:14px 16px;border-radius:14px;background:rgba(255,255,255,.13);font-size:15px;color:#fff;line-height:1.4;\"><svg width=\"17\" height=\"17\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" style=\"vertical-align:-3px;margin-right:9px;\"><rect x=\"3\" y=\"5\" width=\"18\" height=\"16\" rx=\"2.5\"/><path d=\"M8 3v4\"/><path d=\"M16 3v4\"/><path d=\"M3 10h18\"/></svg>Avoid late fee by paying before the due date.</div></div>",
          buttons:[
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "Pay Now",
              url: "https://payment-link.com",
              style: {
                background: "#D02D22",
                color: "#fff"
              }
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "View Bill",
            }
          ]
        },
        timestamp: new Date()
      },
    ],
    android: [
      {
        cmid: "message1",
        type: MESSAGE_TYPES.TEXT,
        sender: MESSAGE_SENDER.CHATBOT,
        inputLock: false,
        quickReplies: [],
        skipLS: false,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: '',
        delay: 0,
        payload: {
          text: "Hi, I'm Vic, your personal Vi assistant."
        },
        timestamp: new Date()
      },
      {
        cmid: "msg2",
        sender: MESSAGE_SENDER.CHATBOT,
        type: MESSAGE_TYPES.TEXT_WITH_BUTTONS,
        inputLock: false,
        inputLockMessage: '',
        quickReplies: [],
        skipLS: true,
        send_variable_to_apiai: false,
        sendVariableToLS: false,
        variable_name: 'subscription',
        delay: 0,
        payload: {
          title: "",
          subtitle: "What would you like to explore today?",
          buttons: [
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "Prepaid",
              url: ""
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "Postpaid",
              url: ""
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "Join Vi Family",
              url: ""
            },
            {
              type: BUTTON_TYPES.DEFAULT,
              text: "हिंदी भाषा में दिखाएं",
              url: ""
            }
          ]
        },
        timestamp: new Date(),
      }
    ],
  }
  return defaultMessgaes[key] || []
}
